import { Account } from 'model/IChat';

export interface FeatureFlag {
  title: string;
  description: string;
  localStorageKey: string;
  autoAssignTrafficPercentage?: number;
  disableAfterDate?: Date;
  betaUsers?: Set<string>;
}

const flags = {
  LOCALS_PRODUCT_PAGE: {
    title: 'Display locals slider on mobile product page',
    description: 'Turn on the AB test for mobile produt page with locals slider',
    localStorageKey: 'localsonproduct',
  },
  UPSELL: {
    title: 'Upsell stuff',
    description: 'Turn on to see the upsell for specific experiences',
    localStorageKey: 'upsell',
  },
  TRANSLATE_BUTTON: {
    title: 'Show translate button',
    description: 'Turn on to show Translate with Google button',
    localStorageKey: 'translate_button',
  },
  LOCAL_PICKER_EXPERIMENT: {
    title: 'Localpicker experiment',
    description: 'Turn on the localpicker ab test where the local picker is turned off for some users in a segment',
    localStorageKey: 'local_picker_experiment',
  },
  NEW_HOST_CAROUSEL_MOBILE: {
    title: 'New host carousel on mobile local picker',
    description: 'Turn on to see the new host carousel on mobile local picker which attempts to fix some performance issues',
    localStorageKey: 'new_host_carousel_mobile',
  },
  HOST_STATUS: {
    title: 'Update for host status',
    description: 'Turn on to see the update for the host status feature',
    localStorageKey: 'host_status',
  },
};

function getParseOrElse<T>(key: string, orElse: T) {
  return JSON.parse(getOrElse(key, JSON.stringify(orElse))) as T;
}
function getOrElse(key: string, orElse: string) {
  try {
    const value = localStorage.getItem(key);
    if (value === null || value === undefined) return orElse;
    return value;
  } catch (e) {
    return orElse;
  }
}

function setJson(key: string, value: any) {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    return;
  }
}

function autoAssignIfNeeded(flag: FeatureFlag) {
  if (!flag.autoAssignTrafficPercentage) return ;
  const isAutoAssigned = getParseOrElse<boolean>(`${flag.localStorageKey}.autoassigned`, false)
  if (!isAutoAssigned) {
    // auto assign
    const value = Math.random() * 100;
    const flagValue = value <= flag.autoAssignTrafficPercentage;
    console.log('auto assigning feature flag', flag, flagValue)
    setJson(`${flag.localStorageKey}.autoassigned`, true)
    setFlag(flag, flagValue);
  }
}

function isSet(flag: FeatureFlag): boolean {
  autoAssignIfNeeded(flag);
  return getParseOrElse(flag.localStorageKey, false);
}

function setFlag(flag: FeatureFlag, value: boolean) {
  setJson(flag.localStorageKey, value);
}

function toggleFlag(flag: FeatureFlag) {
  return setFlag(flag, !isSet(flag));
}

const flagList: FeatureFlag[] = Object.values(flags);

const serializeFeatureFlags = () => {
  return flagList.filter(isSet).map(item => item.localStorageKey).join(',');
}
const setFeatureFlagsFromSerialized = (input: string) => {
  const flags = input.split(",")
    .map(ff => flagList.find(item => item.localStorageKey === ff))
    .filter(x => !!x);
  if (flags && flags.length > 0) {
    flags.forEach(flag => isSet(flag) ? null : toggleFlag(flag));
  }
}

const isFeatureFlagSetForAccount = (account: Account, flagString: string) => {
  return account?.feature_flags?.includes(flagString);
}

export default {
  setFeatureFlagsFromSerialized,
  serializeFeatureFlags,
  flags,
  flagList,
  isSet,
  toggleFlag,
  isFeatureFlagSetForAccount
};
